/**
 * Sprint 22 — per-message completion footer (ported from Sprint 3.2). Shows
 * duration · tokens · tool calls · model under the last assistant message.
 */
interface ChatCompletionLineProps {
  inputTokens: number;
  outputTokens: number;
  durationMs: number;
  model: string;
  toolCalls: number;
}

export function ChatCompletionLine({
  inputTokens,
  outputTokens,
  durationMs,
  model,
  toolCalls,
}: ChatCompletionLineProps) {
  const duration =
    durationMs < 1000
      ? `${durationMs}ms`
      : `${(durationMs / 1000).toFixed(1)}s`;

  const tokens = `${(inputTokens + outputTokens).toLocaleString()} tokens`;
  const tools = toolCalls > 0 ? ` · ${toolCalls} tool calls` : "";
  const modelShort = model.replace(/^claude-/, "").replace(/-\d{8}$/, "");

  return (
    <div className="mt-3 pt-2 border-t border-white/5 text-[11px] text-on-surface-variant/40 tabular-nums select-text">
      {duration} · {tokens}{tools} · {modelShort}
    </div>
  );
}
